import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { CurrentHubService } from '@shared/services/currentHub.service';
import { getEditorTargetUrl, validateCurrentUrl } from '@shared/utils/url-builder.utils';

export const RedirectGuard = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> => {
  const hubService = inject(CurrentHubService);
  let hub = hubService.hub;
  if (!hub && route.params['urlTitle']) {
    try {
      const hubURLTitle = route.params['urlTitle'];
      hub = await hubService.getOrSetCurrentHub(hubURLTitle);
    } catch (err) { console.warn(err) }
  }
  const targetEndPoint = getEditorTargetUrl(hub?.mode)
  if (!validateCurrentUrl(targetEndPoint)) {
    window.location.replace(targetEndPoint + state.url);
    return false; // because we navigated manually
  }
  return true;
}